import React from 'react';
import RadioButton from '../RadioButton';

/**
 * RadioButton/Large — Figma 3804:18116
 * 32px selector · title `typo-h4` · description `typo-body` · success-green fill.
 */
const RadioButtonLarge = (props) => <RadioButton {...props} size="large" />;

export default RadioButtonLarge;
